import React from 'react';

/**
 * The SimpleFormat logic is based on the simple_format and auto_link methods from Ruby on Rails
 * https://apidock.com/rails/v3.0.9/ActionView/Helpers/TextHelper/simple_format
 * https://apidock.com/rails/v3.0.9/ActionView/Helpers/TextHelper/auto_link
 *
 * auto_link: Turns all URLs and e-mail addresses into clickable links.
 * simple_format: Returns text transformed into HTML using simple formatting rules. Two or more
 * consecutive newlines(\n\n) are considered as a paragraph and wrapped in <p> tags. One newline
 * (\n) is considered as a linebreak and a <br /> tag is appended. This method does not remove
 * the newlines from the text.
 *
 */
type Props = {
  value: string;
};
export default function SimpleFormat({ value }: Props): JSX.Element[] {
  return value
    .replace(/\r\n/g, '\n')
    .replace(/\n\n+/, '\n\n')
    .split('\n\n')
    .map((string, i) => {
      return <p key={`simple-format-${i}`}>{getParagraphBody(string)}</p>;
    });
}

function getParagraphBody(text: string) {
  const result = text.split('\n');
  return result.map((text, index) => {
    if (index === result.length - 1) {
      return <React.Fragment key={index}>{getEnrichedLinksBody(text)}</React.Fragment>;
    }
    return (
      <React.Fragment key={index}>
        {getEnrichedLinksBody(text)}
        <br />
      </React.Fragment>
    );
  });
}

function getEnrichedLinksBody(textToCheck: string): JSX.Element[] {
  if (textToCheck.length == 0) {
    return [];
  }

  const tokens = textToCheck.split(/\s+/);
  return tokens.map((token, i) => {
    const suffix = i === tokens.length - 1 ? '' : ' ';
    if (token.startsWith('https://') || token.startsWith('http://')) {
      return (
        <React.Fragment key={i}>
          <a href={token} target="_blank" rel="noreferrer">
            {token}
          </a>
          {suffix}
        </React.Fragment>
      );
    }
    return (
      <React.Fragment key={i}>
        {token}
        {suffix}
      </React.Fragment>
    );
  });
}
